import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop — restablece el scroll al inicio en cada cambio de ruta SPA.
 *
 * Sin esto, react-router conserva la posición de scroll anterior al navegar
 * (p. ej. desde el footer de la landing a un documento legal, o entre las
 * páginas públicas de marketing). Como el nuevo contenido puede ser más corto
 * que el desplazamiento previo, la página parecía quedarse "en blanco" (en
 * realidad estaba desplazada por debajo de todo su contenido).
 *
 * Se usa `useLayoutEffect` para reposicionar antes del primer pintado y evitar
 * un parpadeo en la posición vieja. Solo se dispara al cambiar `pathname` (no
 * en cambios de query/hash) para no interferir con anclas dentro de una página.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
